import Api from "@/lib/axios";

const PayoutMethodService = {
  getList(params) {
    return Api.get("/api/autopricing/onload/payout-methods", {
      data: params,
      tenant: true
    }).then(response => response?.data || []);
  }
};

export default PayoutMethodService;
